import "./index.css";
import Midtrans from "./pages/midtrans";
import { useEffect, useState, type FormEvent } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { login, getAuthToken } from "./features/midtrans/actions";

const queryClient = new QueryClient();

export function App() {
  const [isLogin, setIsLogin] = useState<boolean | null>(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, []);

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault();
    setErrorMsg(null);
    setLoading(true);

    const result = await login(username, password);
    setLoading(false);

    if (result.success) {
      setIsLogin(true);
    } else {
      setErrorMsg(result.error || "Autentikasi gagal");
    }
  };

  if (isLogin === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-background text-muted text-sm font-medium tracking-wide">
        System Initializing...
      </div>
    );
  }

  if (isLogin === false) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background relative px-4">
        <div className="w-full max-w-sm p-8 bg-surface border border-border shadow-sm rounded-lg">
          <div className="mb-8">
            <h1 className="text-xl font-semibold text-foreground mb-1">Authorization</h1>
            <p className="text-sm text-muted">Sign in to access the routing console.</p>
          </div>
          <form className="space-y-5" onSubmit={handleLogin}>
            <div className="space-y-4">
              <div>
                <label htmlFor="identity" className="block text-sm font-medium text-foreground mb-1.5">Username / Email</label>
                <input
                  id="identity"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full bg-surface border border-border rounded-md px-3 py-2.5 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-shadow"
                  placeholder="admin"
                  autoComplete="username"
                  required
                />
              </div>
              <div>
                <label htmlFor="passcode" className="block text-sm font-medium text-foreground mb-1.5">Passcode</label>
                <input
                  id="passcode"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-surface border border-border rounded-md px-3 py-2.5 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-shadow"
                  placeholder="••••••••"
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>
            {errorMsg && (
              <p id="login-error" className="text-destructive text-sm font-medium bg-destructive/10 px-3 py-2 rounded-md border border-destructive/20" role="alert">
                {errorMsg}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground font-medium rounded-md py-2.5 text-sm hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:ring-primary transition-colors cursor-pointer mt-6 shadow-sm disabled:opacity-50"
            >
              {loading ? "Authenticating..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="min-h-screen bg-background text-foreground flex flex-col font-sans">
        <Midtrans />
      </div>
    </QueryClientProvider>
  );
}

export default App;
